<template>
    <CCard class="Payment_Extension">
        <CCardHeader class="bgcolor grey-header d-flex">
            <CRow class="exchangeRateTable flex-flow-column">
                <CCol>
                    <strong>{{$t('extensionSetUp.paymtExt')}}</strong>
                </CCol>
                <p class="desc"> {{$t('extensionSetUp.desc')}}
                    <!-- {{ $t("exchngRt.desc") }} -->
                </p>
            </CRow>
        </CCardHeader>
        <CCardBody v-if="isEdit">
            <div class="w-100 overflow-x-auto-mx-600">
            <div class="table-wrap">
                <div class="t-col">
                    <div class="t-row">

                    </div>
                    <div class="t-row">
                        {{$t('extensionSetUp.allowExt')}}
                    </div>
                    <div class="t-row">
                        {{$t('extensionSetUp.maxExt')}}
                    </div>
                    <div class="t-row">
                        {{$t('extensionSetUp.maxExtTime')}}
                    </div>


                </div>
                <div class="t-col" v-for="(res,index) in extensionSetUpRes" :key="index+'extension'">
                    <div class="t-row">
                        <div v-if="res.postpaidtype && res.postpaidtype==1">
                            {{$t('extensionSetUp.weekly')}}
                        </div>
                        <div v-if="res.postpaidtype && res.postpaidtype==2">
                            {{$t('extensionSetUp.twice')}}
                        </div>
                        <div v-if="res.postpaidtype && res.postpaidtype==3">
                            {{$t('extensionSetUp.monthly')}}
                        </div>
                    </div>
                    <div class="t-row">
                        {{ $tc('extensionSetUp.Day', res.extensionStarts, { count: Number(res.extensionStarts) })}}
                    </div>
                    <div class="t-row">
                        {{ $tc('extensionSetUp.Day', res.maxExtensiondays, { count: Number(res.maxExtensiondays) })}}
                    </div>
                    <div class="t-row">
                        {{ $tc('extensionSetUp.Time', res.maxExtensiontimes, { count: Number(res.maxExtensiontimes) }) }}
                    </div>


                </div>
            </div>
            </div>

            <!--    <CRow>-->
            <!--        <CCol col="3"></CCol>-->
            <!--        <CCol col="3">Allow extension 'n' days before settlement date</CCol>-->
            <!--        <CCol col="3">Maximum extension days at a time</CCol>-->
            <!--        <CCol col="3">Maximum Extension Times</CCol>-->
            <!--      </CRow>-->
            <!--      <br />-->
            <!--      <div v-for="(res,index) in extensionSetUpRes" :key="index+'extension'">-->
            <!--        <CRow>-->
            <!--          <CCol col="3">-->
            <!--            <div v-if="res.postpaidtype && res.postpaidtype==1">-->
            <!--              <div>Weekly</div>-->
            <!--            </div>-->
            <!--            <div v-if="res.postpaidtype && res.postpaidtype==2">-->
            <!--              <div>Twice a Week</div>-->
            <!--            </div>-->
            <!--            <div v-if="res.postpaidtype && res.postpaidtype==3">-->
            <!--              <div>Monthly</div>-->
            <!--            </div>-->
            <!--          </CCol>-->
            <!--          -->
            <!--          <CCol col="3">{{ res.extensionStarts+' Days' }}</CCol>-->
            <!--          <br /><br />-->
            <!--          <CCol col="3">{{ res.maxExtensiondays+' Days' }}</CCol>-->
            <!--          <br /><br />-->
            <!--          <CCol col="3">{{ res.maxExtensiontimes+' Times' }}</CCol>-->
            <!--          <br /><br />-->
            <!--        </CRow>-->
            <!--      </div>-->
        </CCardBody>
        <CCardBody v-else>
<div class="w-100 overflow-x-auto-mx-600">
    <div class="table-wrap">
        <div class="t-col">
            <div class="t-row"></div>
            <div class="t-row">
                        {{$t('extensionSetUp.allowExt')}}
                    </div>
                    <div class="t-row">
                        {{$t('extensionSetUp.maxExt')}}
                    </div>
                    <div class="t-row">
                        {{$t('extensionSetUp.maxExtTime')}}
                    </div>
        </div>
        <div class="t-col" v-for="(res,index) in extensionSetUpRes" :key="index+'extension'">
            <div class="t-row">
                 <div v-if="res.postpaidtype && res.postpaidtype==1">
                            {{$t('extensionSetUp.weekly')}}
                        </div>
                        <div v-if="res.postpaidtype && res.postpaidtype==2">
                            {{$t('extensionSetUp.twice')}}
                        </div>
                        <div v-if="res.postpaidtype && res.postpaidtype==3">
                            {{$t('extensionSetUp.monthly')}}
                        </div>
                
            </div>
            <div class="t-row">     <div class="PE_dropdown">
               
                <multiselect
                        :searchable="false"
                        :close-on-select="true"
                        :track-by="'code'"
                        :label="'name'"
                        v-model="editedData.weekly[index]"
                        :show-labels="false"
                        :options="twiceWeekOptions"
                        :allowEmpty="false"
                ><span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                </multiselect>
                <!-- <span>Days</span> -->
            </div></div>
            <div class="t-row">    <div class="PE_dropdown">
                <div v-if="index<2">
                    <multiselect
                            :searchable="false"
                            :track-by="'code'"
                            :label="'name'"
                            :close-on-select="true"
                            v-model="editedData.twiceWeek[index]"
                            :show-labels="false"
                            :options="weekOption"
                          :allowEmpty="false"

                    >
                    <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                    </multiselect>
                </div>
                <div v-else>
                    <multiselect
                            :searchable="false"
                            :close-on-select="true"
                            :track-by="'code'"
                            :label="'name'"
                            v-model="editedData.twiceWeek[index]"
                            :show-labels="false"
                            :options="monthOptions"
                         :allowEmpty="false"

                    >
                    <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                    </multiselect>
                </div>
                <!-- <span>Days</span> -->
            </div></div>
            <div class="t-row"> <div class="PE_dropdown">
            <!-- {{editedData.monthly[index]}} -->
                <multiselect
                        
                        :searchable="false"
                        :track-by="'code'"
                        :label="'name'"
                        :close-on-select="true"
                        v-model="editedData.monthly[index]"
                        :show-labels="false"
                        :options="optionLs"
                      :allowEmpty="false"

                >
                <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                </multiselect>
                <!-- <span>Times</span> -->
            </div></div>
        </div>
        <cAlertModal
                v-if="isShowAlertModal"
                :key="'CA'+alertCount"
                :buttonList="modalButton"
                :status="modalStatus"
                :isShowIcon="true"
                :show="isShowAlertModal"
                :desc="confirmTxt"
        ></cAlertModal>

    </div>
</div>

<!--            <CRow>-->
<!--                <CCol col="3"></CCol>-->
<!--                <CCol col="3">Allow extension 'n' days before settlement date</CCol>-->
<!--                <CCol col="3">Maximum extension days at a time</CCol>-->
<!--                <CCol col="3">Maximum Extension Times</CCol>-->
<!--            </CRow>-->
<!--            <br/>-->
<!--            <div v-for="(res,index) in extensionSetUpRes" :key="index+'extension'">-->
<!--                <CRow>-->
<!--                    <CCol col="3">-->
<!--                        <div v-if="res.postpaidtype && res.postpaidtype==1">-->
<!--                            <div>Weekly</div>-->
<!--                        </div>-->
<!--                        <div v-if="res.postpaidtype && res.postpaidtype==2">-->
<!--                            <div>Twice a Week</div>-->
<!--                        </div>-->
<!--                        <div v-if="res.postpaidtype && res.postpaidtype==3">-->
<!--                            <div>Monthly</div>-->
<!--                        </div>-->
<!--                    </CCol>-->
<!--                    <CCol col="3">-->
<!--                        <CRow>-->
<!--                            <CCol col="8">-->
<!--                                <multiselect-->
<!--                                        v-model="editedData.weekly[index]"-->
<!--                                        :show-labels="false"-->
<!--                                        :options="twiceWeekOptions"-->
<!--                                ></multiselect>-->
<!--                            </CCol>-->
<!--                            <CCol col="4">-->
<!--                                <span>Days</span>-->
<!--                            </CCol>-->
<!--                        </CRow>-->
<!--                    </CCol>-->
<!--                    <CCol col="3">-->
<!--                        <CRow>-->
<!--                            <CCol col="8" v-if="index<2">-->
<!--                                <multiselect-->
<!--                                        v-model="editedData.twiceWeek[index]"-->
<!--                                        :show-labels="false"-->
<!--                                        :options="weekOption"-->
<!--                                ></multiselect>-->
<!--                            </CCol>-->
<!--                            <CCol col="8" v-else>-->
<!--                                <multiselect-->
<!--                                        v-model="editedData.twiceWeek[index]"-->
<!--                                        :show-labels="false"-->
<!--                                        :options="monthOptions"-->
<!--                                ></multiselect>-->
<!--                            </CCol>-->
<!--                            <CCol col="4">-->
<!--                                <span>Days</span>-->
<!--                            </CCol>-->
<!--                        </CRow>-->
<!--                    </CCol>-->
<!--                    <CCol col="3">-->
<!--                        <CRow>-->
<!--                            <CCol col="8">-->
<!--                                <multiselect-->
<!--                                        v-model="editedData.monthly[index]"-->
<!--                                        :show-labels="false"-->
<!--                                        :options="optionLs"-->
<!--                                ></multiselect>-->
<!--                            </CCol>-->
<!--                            <CCol col="4">-->
<!--                                <span>Times</span>-->
<!--                            </CCol>-->
<!--                        </CRow>-->
<!--                    </CCol>-->
<!--                </CRow>-->
<!--            </div>-->
<!--            <cAlertModal-->
<!--                    v-if="isShowAlertModal"-->
<!--                    :key="'CA'+alertCount"-->
<!--                    :buttonList="modalButton"-->
<!--                    :status="modalStatus"-->
<!--                    :isShowIcon="true"-->
<!--                    :show="isShowAlertModal"-->
<!--                    :desc="confirmTxt"-->
<!--            ></cAlertModal>-->
        </CCardBody>
        <CCardFooter class="d-flex justify-content-end">
            <CRow>
                <CCol>
                    <div>
                        <div v-show="isEdit">
                            <CButton @click="goToEditMode()" color="info" class="action-c-btn ml-auto ml-10px dull-blue">
                                <!-- <img src="@imgPath/img/svg/icons/edit.svg" class="filter-inherit" /> -->
                                {{ $t("extensionSetUp.editBtn") }}
                            </CButton>
                        </div>
                        <div v-show="!isEdit" id="exchange-edit-btn">
                            <CButton 
                                    color="danger"
                                    style="margin-right: 16px"
                                    class=""
                                    @click="goToEditMode()"
                            >{{
                                $t("extensionSetUp.cancelBtn")
                                }}
                            </CButton>

                            <CButton @click="toUpdateExtDueDate()" color="success">
                                {{
                                $t("extensionSetUp.saveBtn")
                                }}
                            </CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>
        </CCardFooter>
        <CAlert v-if="alertValue" show color="danger">
                <div v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                    <p v-for="(value,index) in alertValue.valueList" :key="index">{{value}}</p>
                </div>
                <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                    <span>{{$t("cAlert.errorCode")+' : '}}</span>
                    <span v-for="(code,index) in alertValue.codeList" :key="index">{{code +' '}}</span>
                </div>
                <div v-if="alertValue&&alertValue.constructor==String">
                    <p>{{alertValue}}</p>
                </div>
            </CAlert>
    </CCard>
</template>
<script>
    import cAlertModal from "./../../components/form/cAlertModal";
    import Multiselect from "vue-multiselect";
    import router, {navigate, goBack, updateDataEdited} from "../../router/index";
    import {
        cloneData,
        removeDuplicates,
        OrderByList,
        addClassToBody,
        removeClassBody
    } from "./../../util/util";
    import {ValidationObserver, localize} from "vee-validate";
    import {mapGetters, mapActions} from "vuex";
    import draggable from "vuedraggable";
    import {
        PATHNAME,
        COMPONENT_NAME,
        DEFAULT_DROPDOWN_STATUS,
        ALERT_MODAL_STATUS
    } from "./../../util/constants";
    import apiGetExtensionSetUp from "./../../services/apiGetExtensionSetUp";
    import apiUpdateExtensionSetUp from "./../../services/apiUpdateExtensionSetUp";
    import Logger from "./../../services/logger";
    import SERVICE_URL, {
        FILE_NAME,
        LOG_TYPE,
        HTTP_CODES,
        API_VALUES
    } from "./../../config/API_DATA";
    import BaseConfiguration from "./../../config/base";
    import {VALIDATE_SUCCESS_RES, getErrorMessage} from "../../util/apiValidate";
    import {handleJWT, getErrorAlertValue} from "../../util/util";

//     import nb from "../../translations/validation/nb.json";
//     import en from "../../translations/validation/en.json";

//      localize({

//   en: {
//     messages: en.messages.extensionSetUp,
    
//   },
//         nb: {
//             messages: nb.messages.extensionSetUp
//         }
         
//     });

    export default {
        name: COMPONENT_NAME.EXTENSION_SETUP,
        components: {
            Multiselect,
            cAlertModal
        },
        data() {
            return {
                extensionSetUpRes: null,
                isEdit: true,
                isShowAlertModal: false,
                weekOption: [],
                optionLs: [],
                twiceWeekOptions: [],
                monthOptions: [],
                editedData: {
                    weekly: [],
                    twiceWeek: [],
                    monthly: []
                },
                alertCount:0,
                modalStatus: ALERT_MODAL_STATUS.INFO,
                modalButton: null,
                alertValue:null,
            };
        },

        methods: {

            goToEditMode() {
                try {
                    if (BaseConfiguration.isDebug) console.log("goToEditMode");
                    if (this.extensionSetUpRes) {
                        this.editedData.weekly=[]
                        this.editedData.twiceWeek=[]
                        this.editedData.monthly=[]
               
                        for (let i = 0; i < this.extensionSetUpRes.length; i++) {
                            this.editedData.weekly.push({name:this.$tc('extensionSetUp.Day', Number(this.extensionSetUpRes[i].extensionStarts),
                                                         { count: Number(this.extensionSetUpRes[i].extensionStarts) }),code:Number(this.extensionSetUpRes[i].extensionStarts)})
                            this.editedData.twiceWeek.push({name:this.$tc('extensionSetUp.Day', Number(this.extensionSetUpRes[i].maxExtensiondays),
                                                         { count: Number(this.extensionSetUpRes[i].maxExtensiondays) }),code:Number(this.extensionSetUpRes[i].maxExtensiondays)})
                            this.editedData.monthly.push({name:this.$tc('extensionSetUp.Time', Number(this.extensionSetUpRes[i].maxExtensiontimes),
                                                         { count: Number(this.extensionSetUpRes[i].maxExtensiontimes) }),code:Number(this.extensionSetUpRes[i].maxExtensiontimes)})
                        }
                        this.isEdit = !this.isEdit;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.EXTENSION_SETUP,
                        "error in goToEditMode",
                        err.toString(),
                        "goToEditMode",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            toUpdateExtDueDate() {
                try {
                    if (BaseConfiguration.isDebug) console.log("toUpdateExtDueDate");
                    this.showAlertModal(
                        ALERT_MODAL_STATUS.INFO,
                        this.$t("extensionSetUp.editStateConfirm")
                    );
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.EXTENSION_SETUP,
                        "error in toUpdateExtDueDate",
                        err.toString(),
                        "toUpdateExtDueDate",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },

            showAlertModal(status, val) {
                this.isShowAlertModal = true;
                this.alertCount += 1;
                this.modalStatus = status;

                if (status == ALERT_MODAL_STATUS.INFO) {
                    this.modalButton = [
                        {
                            name: this.$t("extensionSetUp.cancel"),
                            func: this.toggleShowAlertModal
                        },
                        {
                            name: this.$t("extensionSetUp.yes"),
                            func: this.toGetEditedObj
                        }
                    ];
                } else if (status == ALERT_MODAL_STATUS.SUCCESS || status == ALERT_MODAL_STATUS.FAIL) {
                    this.modalButton = [
                        {
                            name: this.$t("extensionSetUp.ok"),
                            func: this.toggleShowAlertModal
                        }
                    ];
                }
                this.confirmTxt = val;
            },

            async toggleShowAlertModal() {
                this.extensionSetUpRes = await this.getExtensionSetUp();
                this.isEdit = !this.isEdit;
                this.isShowAlertModal = !this.isShowAlertModal;
                this.modalStatus = ALERT_MODAL_STATUS.INFO;
            },

            async toGetEditedObj() {
                let retValue = {
                    id: 0,
                    postpaidtype: 0,
                    maxExtensiondays: 0,
                    maxExtensiontimes: 0,
                    extensionStarts: 0
                };
                let objtoUpdate = [];
                let pEditedData = this.editedData;
                try {
                    if (BaseConfiguration.isDebug) console.log("toGetEditedObj");
                    this.isShowAlertModal = false;
                    for (let i = 0; i < 3; i++) {
                        objtoUpdate.push(cloneData(retValue));
                        objtoUpdate[i].id =this.extensionSetUpRes[i].id;
                        objtoUpdate[i].postpaidtype = this.extensionSetUpRes[i].postpaidtype;
                        objtoUpdate[i].maxExtensiondays = pEditedData.twiceWeek[i].code;
                        objtoUpdate[i].maxExtensiontimes = pEditedData.monthly[i].code;
                        objtoUpdate[i].extensionStarts = pEditedData.weekly[i].code;
                    }

                    this.updateExtSetupRes = await this.getUpdateExtSetUp(objtoUpdate);
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.EXTENSION_SETUP,
                        "error in toGetEditedObj",
                        err.toString(),
                        "toGetEditedObj",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },

            async getExtensionSetUp() {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getExtensionSetUp");

                    let extensionSetUpReq = apiGetExtensionSetUp.buildRequest();

                    if (extensionSetUpReq) {
                        let extensionSetUpRes = await apiGetExtensionSetUp.getResponse(
                            extensionSetUpReq
                        );
                        if (VALIDATE_SUCCESS_RES(extensionSetUpRes)) {
                            // this.toggleAlertModal();
                            retValue = extensionSetUpRes.data.data;
                            this.alertValue = null;
                        } else {
                            let error = getErrorMessage(extensionSetUpRes);

                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.alertValue = getErrorAlertValue(error);
                            }
                        }
                    } else {
                        throw "invalid payment request";
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.PAYMENT_SETUP,
                        "error in getExtensionSetUp",
                        err.toString(),
                        "getExtensionSetUp",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            async getUpdateExtSetUp(pExtRes) {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getUpdateExtSetUp");
                    let updateExtSetUpReq = apiUpdateExtensionSetUp.buildRequest(pExtRes);

                    if (updateExtSetUpReq) {
                        let updateExtSetUpRes = await apiUpdateExtensionSetUp.getResponse(
                            updateExtSetUpReq
                        );
                        if (VALIDATE_SUCCESS_RES(updateExtSetUpRes)) {
                            // this.toggleAlertModal();
                            retValue = updateExtSetUpRes.data.data;
                            this.showAlertModal(
                                ALERT_MODAL_STATUS.SUCCESS,
                                this.$t("extensionSetUp.editSuccess")
                            );
                            this.alertValue = null;
                        } else {
                            let error = getErrorMessage(updateExtSetUpRes);
                            
                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.alertValue = getErrorAlertValue(error,true,true);
                            }
                            this.showAlertModal(
                                ALERT_MODAL_STATUS.FAIL,
                                this.alertValue
                                );
                        }
                    } else {
                        throw "invalid payment request";
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.PAYMENT_SETUP,
                        "error in getUpdateExtSetUp",
                        err.toString(),
                        "getUpdateExtSetUp",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },


            toGetMonthOptions() {
                let retValue = [];
                for (let index = 1; index <= 30; index++) {
                    
                    if (index < 6) {
                       
                            this.optionLs.push({name:this.$tc('extensionSetUp.Time', index, { count: index }),code:index});
                       
                    }
                    if (index < 8) {
                        this.weekOption.push({name:this.$tc('extensionSetUp.Day', index, { count: index }),code:index});
                    
                    }
                    if (index < 11) {
                        this.twiceWeekOptions.push({name:this.$tc('extensionSetUp.Day', index, { count: index }),code:index});
                        
                    }
                   
                    retValue.push({name:this.$tc('extensionSetUp.Day', index, { count: index }),code:index});
                    
                }
                return retValue;
            }
        },

        async created() {
            this.monthOptions = this.toGetMonthOptions();
            this.extensionSetUpRes = await this.getExtensionSetUp();
            // if (this.extensionSetUpRes) {
            //   this.updateExtSetupRes = await this.getUpdateExtSetUp(
            //     this.extensionSetUpRes
            //   );
            // }
            // this.dataField = this.getDataField();
        },
        beforeCreate() {
            addClassToBody(COMPONENT_NAME.STATE_PROVINCE);
        },

        beforeDestroy() {
            removeClassBody();
        }
    };
</script>